const module = { name: 'movie/castCrew/castCrew.tabs', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



const Selectors = {
    TAB_LINK: '.js-castCrewTabs-link',
}


const Styles = {
    HIDE: 'hide',
    SELECTED: 'movie-info-tabs__tab--is-selected',
}


const Map = {
    cast: 'crew',
    crew: 'cast'
}


let currentTab = 'cast'
function init() {
    $(Selectors.TAB_LINK).on('click', (e) => {
        const tab = $(e.currentTarget).data('tab');
        if (tab === currentTab) {
            return;
        }
        else {
            $(`.js-castCrewTabs-tab[data-tab=${tab}]`).addClass(Styles.SELECTED);
            $(`.js-castCrewTabs-tab[data-tab=${Map[tab]}]`).removeClass(Styles.SELECTED);
            $(`#${tab}-container`).removeClass(Styles.HIDE);
            $(`#${Map[tab]}-container`).addClass(Styles.HIDE);
            $(`.js-castCrewTabs-link[data-tab=${tab}]`).attr('aria-checked', true);
            $(`.js-castCrewTabs-link[data-tab=${Map[tab]}]`).attr('aria-checked', false);
            currentTab = tab;
        }
    });
}
module.exports = {
    init
};
export default module.exports;